/**
 * @module app.bdc.reports.bdcFleuristeCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BdcFleuristeCtrl($scope, $window, $rootScope, pricesService, reportRoutingService) {
        var self = {};
        /* Init */
        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.user = $rootScope.user;
        self.order = $rootScope.order;

        // Calculate the prices without and with TVA
        self.packageInstallationPriceHT = pricesService.calculatePackagePrice('formationPrice');
        self.packageSubscriptionPriceHT = pricesService.calculatePackagePrice('subscriptionPrice');
        self.packageInstallationPriceTTC = pricesService.calculatePackagePrice('formationPrice', true);
        self.packageSubscriptionPriceTTC = pricesService.calculatePackagePrice('subscriptionPrice', true);

        // Only if package is defined (only web tills)
        if (self.order.package.id) {
            // Data come from object order or from object orderForm
            self.packagePriceFormationDescription = self.order.package.prices
                ? self.order.package.prices[0].formationDescription
                : self.order.package.price.formationDescription;
            self.packagePriceSubscriptionDescription = self.order.package.prices
                ? self.order.package.prices[0].subscriptionDescription
                : self.order.package.price.subscriptionDescription;
        }
        else {
            self.packagePriceFormationDescription = '';
            self.packagePriceSubscriptionDescription = '';
        }

        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        if (self.order.offer.code === 'materialTill') {
            openFleuristeReport('TABACPRESSE');
        }
        else if (self.order.offer.code === 'webTill') {
            openFleuristeReport('FLEURISTE');
        }

        /* Functions */

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get installation date if defined
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        function openFleuristeReport(reportName) {
            reportRoutingService.openReport(reportName, self.order);
        }

        return self;
    }

    BdcFleuristeCtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService', 'reportRoutingService'];

    angular.module('app.bdc.reports.bdcFleuristeCtrl', []).controller('BdcFleuristeCtrl', BdcFleuristeCtrl);
});
